import { useMediaQuery, useTheme } from '@material-ui/core'
import TextField from '@material-ui/core/TextField/TextField'
import Typography from '@material-ui/core/Typography/Typography'

import { useStyles } from './styles/RatePlansCodeMapingModalRow.styles'

interface RatePlansCodeMapingModalRowProps {
  AdotelName: string
  AdotelCode: string
  ChannelCode: string
  ProviderName: string
  onChange: (event: string) => void
}
const RatePlansCodeMapingModalRow: React.FC<
  RatePlansCodeMapingModalRowProps
> = ({ AdotelName, AdotelCode, ChannelCode, ProviderName, onChange }) => {
  const classes = useStyles()
  const theme = useTheme()

  return (
    <div className={classes.mainDiv}>
      <div>
        <Typography variant="body1">{AdotelName}</Typography>
      </div>
      <div>
        <Typography variant="body1">{ProviderName}</Typography>
      </div>
      {useMediaQuery(theme.breakpoints.up('sm')) && (
        <div>
          <Typography variant="body1">{AdotelCode}</Typography>
        </div>
      )}
      <div>
        <TextField
          value={ChannelCode}
          variant="outlined"
          size="small"
          onChange={(event) => onChange(event.target.value)}
        />
      </div>
    </div>
  )
}
export default RatePlansCodeMapingModalRow
